import { PHP_API_URL,APP_KEY } from "../../../util/constants";
import request from "../../../util/request";
import Cookies from 'js-cookie';
// 获取资源库列表接口
export function getResourceListRequest(nianji_code,xueke_code,offset,limit, callback) {
    let formData = new FormData();
    formData.append('appkey', "spark");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('caozuo', "get_ziyuan_list");
    formData.append('nianji_code', nianji_code);
    formData.append('xueke_code', xueke_code);
    formData.append('offset', offset);
    formData.append('limit', limit);
    return request(
        PHP_API_URL+'/Jiaoxue_ziyuan/i',
        {
            method: 'POST',
            body: formData
        },
        callback
    );
}

//获取学科列表
export function getXuekeListRequest(
    username,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_nianji_xueke_list');
  formData.append("username",username);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}

export function addResReviewNumRequest(
    code,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append('user_token', Cookies.get("userToken"));
  formData.append("caozuo",'add_ziyuan_review');
  formData.append("ziyuan_code",code);

  return request(PHP_API_URL+'/Jiaoxue_ziyuan/i', {
    method: "POST",
    body: formData,
  }, callback);
}


export function downloadFileRequest(
    code,
    jilu_code,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append('user_token', Cookies.get("userToken"));
  formData.append("caozuo",'download_ziyuan');
  formData.append("ziyuan_code",code);
  formData.append("jilu_code",jilu_code);

  return request(PHP_API_URL+'/Jiaoxue_ziyuan/i', {
    method: "POST",
    body: formData,
  }, callback);
}